import { useTranslation } from 'react-i18next';

import { Icon } from '@/shared/ui/icon';

import type { ListBulkAction } from '../model/types';
import type { ListPageController } from '../model/useListPageController';

/**
 * Hromadná lišta (anatomie region 8) — plovoucí pruh, který se objeví při neprázdném výběru
 * řádků. Nese počet vybraných, akce šablony a zrušení výběru. Výběr přežívá stránkování.
 */
export function BulkBar<TItem>({
  controller,
  actions,
}: {
  controller: ListPageController<TItem>;
  actions?: ListBulkAction[];
}) {
  const { t } = useTranslation('listPage');
  const count = controller.selection.size;

  if (!actions || actions.length === 0 || count === 0) {
    return null;
  }

  const ids = [...controller.selection];

  return (
    <div className="phxlist-bulk" role="toolbar">
      <span className="phxlist-bulk-count">
        <b className="tabular-nums">{count}</b> {t('bulk.selected', { count })}
      </span>
      <span className="phxlist-vdivider" />
      {actions.map((action) => (
        <button
          key={action.key}
          type="button"
          className="phxlist-btn"
          data-tone={action.tone === 'danger' ? 'danger' : undefined}
          onClick={() => void action.run(ids)}
        >
          {action.label}
        </button>
      ))}
      <button
        type="button"
        className="phxlist-btn"
        data-variant="ghost"
        onClick={controller.clearSelection}
      >
        <Icon name="x" size={12} />
        {t('bulk.clear')}
      </button>
    </div>
  );
}
